/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	loadingWrapper: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: token('space.050'),
		marginBottom: token('space.050'),
	},
});

export const LoadingWrapper = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.loadingWrapper} {...props}>
		{children}
	</div>
);
